import React from 'react';

const SvgAw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="AW_svg__d" d="M0 0h28v20H0z" />
      <filter
        x="-7.1%"
        y="-5%"
        width="114.3%"
        height="120%"
        filterUnits="objectBoundingBox"
        id="AW_svg__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={0.5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AW_svg__b" fill="#fff">
        <use xlinkHref="#AW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AW_svg__a" />
      <g mask="url(#AW_svg__b)">
        <use fill="#000" filter="url(#AW_svg__c)" xlinkHref="#AW_svg__d" />
        <use fill="#4189DD" xlinkHref="#AW_svg__d" />
      </g>
      <path
        d="M5.335 5.986l-1.924.604.605-1.923-.605-1.924 1.924.604 1.924-.604-.605 1.924.605 1.923-1.924-.604z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#D21034"
        mask="url(#AW_svg__b)"
        transform="rotate(135 5.335 4.667)"
      />
      <path
        fill="#F9D616"
        mask="url(#AW_svg__b)"
        d="M0 14.667h28V16H0zM0 12h28v1.333H0z"
      />
    </g>
  </svg>
);

export default SvgAw;
